import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useApplyDiscountForParkingTicketValidationSchema = () => {
  const { t } = useTranslation(['visit', 'validation']);
  const invalidTicketNumber = t('visit:modal.validation.invalidTicketNumber');

  return z.object({
    ticketNumber: z
      .number({ invalid_type_error: t('validation:required') })
      .int(invalidTicketNumber)
      .min(1, invalidTicketNumber)
      .max(999_999_999, invalidTicketNumber),
  });
};
